import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  TributacaoMensagemCadastroDto,
  TributacaoMensagemCadastroSchema,
} from "./TributacaoMensagemCadastro.Dto";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  MapearErrosServidor,
  MapearErrosServidorCampo,
} from "src/hook/Functions";
import {
  TributacaoMensagemAtualizar,
  TributacaoMensagemBuscarPorId,
  TributacaoMensagemExcluir,
  TributacaoMensagemIncluir,
} from "src/services/Fiscal.Service";
import { showToast } from "src/componentes";
import { showMessageBox } from "src/componentes/MessageBox/Messagebox";

const TributacaoMensagemCadastroCode = () => {
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [incluir, setIncluir] = useState(false);
  const navigate = useNavigate();
  const id = searchParams.get("id");

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
  } = useForm<TributacaoMensagemCadastroDto>({
    resolver: yupResolver(TributacaoMensagemCadastroSchema),
    defaultValues: {
      padrao: false,
    },
  });

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      try {
        if (id) {
          setLoading(true);
          const response = await TributacaoMensagemBuscarPorId(id);
          if (response.data.success) {
            const data = response.data.data;
            reset(data);
            setIncluir(false);
          } else {
            showToast({
              message: "Ocorreu erro ao carregar a Mensagem",
              title: "Erro",
              variant: "Danger",
            });
          }
        } else {
          setIncluir(true);
        }
      } catch (error) {
        console.error(error);
        showToast({
          message: "Ocorreu erro ao carregar a Mensagem",
          title: "Erro",
          variant: "Danger",
        });
      } finally {
        setLoading(false);
      }
    };
    Load();
    return () => {
      controller.abort();
    };
  }, [id, reset]);

  const onSubmit = async (data: TributacaoMensagemCadastroDto, e?: any) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setLoading(true);
    if (incluir === true) {
      TributacaoMensagemIncluir(data)
        .then((response) => {
          if (response.data.success) {
            showToast({
              message: "Mensagem cadastrada com sucesso",
              title: "Sucesso",
              variant: "Success",
            });
            navigate("/fiscal/tributacao/mensagem");
          } else {
            MapearErrosServidorCampo(response.data.notifications, setError);
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .catch((error) => {
          console.error(error);
          showToast({
            message: "Erro ao incluir mensagem",
            title: "Erro",
            variant: "Danger",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      data.id = Number(id);
      TributacaoMensagemAtualizar(data)
        .then((response) => {
          if (response.data.success) {
            showToast({
              message: "Mensagem atualizada com sucesso",
              title: "Sucesso",
              variant: "Success",
            });
            navigate("/fiscal/tributacao/mensagem");
          } else {
            MapearErrosServidorCampo(response.data.notifications, setError);
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .catch((error) => {
          console.error(error);
          showToast({
            message: "Erro ao atualizar mensagem",
            title: "Erro",
            variant: "Danger",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const onExcluir = () => {
    if (!id) return;
    showMessageBox(
      "Deseja realmente excluir a mensagem?",
      "Atenção!",
      "YesNo",
      "Warning",
      {
        onYes: handleExcluirConfirmado,
      }
    );
  };

  const handleExcluirConfirmado = async () => {
    if (!id) return;
    setLoading(true);
    try {
      const response = await TributacaoMensagemExcluir(Number(id));
      if (response.data.success) {
        showToast({
          message: "Mensagem excluída com sucesso",
          title: "Sucesso",
          variant: "Success",
        });
        navigate("/fiscal/tributacao/mensagem");
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } catch (error) {
      console.error(error);
      showToast({
        message: "Ocorreu erro ao excluir a mensagem",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    onSubmit,
    handleSubmit,
    errors,
    register,
    setValue,
    incluir,
    id,
    onExcluir,
  };
};

export default TributacaoMensagemCadastroCode;
